import SocialMediaCalendar from '../modules/social-media/components/SocialMediaCalendar';// Social Media Page
import React, { useState, useEffect } from 'react';
import PostComposer from '../modules/social-media/components/PostComposer';
import SocialStats from '../modules/social-media/components/SocialStats';
import SocialMediaSettings from '../modules/social-media/components/SocialMediaSettings';
import SocialMediaAnalyticsDashboard from '../modules/social-media/components/SocialMediaAnalytics';
import SocialMediaAIAssistant from '../modules/social-media/components/SocialMediaAI';
import { Share2, BarChart3, Calendar, Settings, Activity, Brain } from 'lucide-react';
import { autoPublishingService } from '../modules/social-media/services/autoPublishing';

const SocialMediaPage: React.FC = () => {
  const [activeView, setActiveView] = useState<'compose' | 'stats' | 'analytics' | 'ai' | 'calendar' | 'settings'>('compose');
  
  // Start auto-publishing service on mount
  useEffect(() => {
    autoPublishingService.start();
    
    return () => {
      autoPublishingService.stop();
    };
  }, []);

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Share2 className="w-8 h-8 text-blue-500 mr-3" />
            <div>
              <h1 className="text-2xl font-bold text-white">Social Media Manager</h1>
              <p className="text-gray-400 mt-1">Zarządzaj swoimi kanałami społecznościowymi</p>
            </div>
          </div>
          
          {/* Navigation */}
          <div className="flex space-x-2">
            <button
              onClick={() => setActiveView('compose')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                activeView === 'compose'
                  ? 'bg-blue-600 text-white'
                  : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
              }`}
            >
              <Share2 className="w-4 h-4 inline mr-2" />
              Tworzenie
            </button>
            <button
              onClick={() => setActiveView('stats')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                activeView === 'stats'
                  ? 'bg-blue-600 text-white'
                  : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
              }`}
            >
              <BarChart3 className="w-4 h-4 inline mr-2" />
              Statystyki
            </button>
            <button
              onClick={() => setActiveView('analytics')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                activeView === 'analytics'
                  ? 'bg-blue-600 text-white'
                  : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
              }`}
            >
              <Activity className="w-4 h-4 inline mr-2" />
              Analityka
            </button>
            <button
              onClick={() => setActiveView('ai')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                activeView === 'ai'
                  ? 'bg-blue-600 text-white'
                  : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
              }`}
            >
              <Brain className="w-4 h-4 inline mr-2" />
              AI Assistant
            </button>
            <button
              onClick={() => setActiveView('calendar')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                activeView === 'calendar'
                  ? 'bg-blue-600 text-white'
                  : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
              }`}
            >
              <Calendar className="w-4 h-4 inline mr-2" />
              Kalendarz
            </button>
            <button
              onClick={() => setActiveView('settings')}
              className={`px-4 py-2 rounded-lg font-medium transition-all ${
                activeView === 'settings'
                  ? 'bg-blue-600 text-white'
                  : 'bg-zinc-800 text-gray-400 hover:text-white hover:bg-zinc-700'
              }`}
            >
              <Settings className="w-4 h-4 inline mr-2" />
              Ustawienia
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div>
        {activeView === 'compose' && <PostComposer />}
        {activeView === 'stats' && <SocialStats />}
        {activeView === 'analytics' && <SocialMediaAnalyticsDashboard />}
        {activeView === 'ai' && <SocialMediaAIAssistant />}
        {activeView === 'calendar' && <SocialMediaCalendar />}
        {activeView === 'settings' && <SocialMediaSettings />}
      </div>
    </div>
  );
};

export default SocialMediaPage;
